// extracted by mini-css-extract-plugin
module.exports =  {"industry-wrapper":"QDgkfip","industryWrapper":"QDgkfip"};